<template>
    <tr>
        <td class="col-xs-2 text-center">
            <input type="checkbox" :checked="selected" @change.prevent="select">
        </td>

        <td>
            {{ subscriptionPeriod.starts_at | date }} - {{ subscriptionPeriod.ends_at | date }}
        </td>

        <td>
            {{ portal.name }}
        </td>

        <td>
            {{ subscriptionPeriod.price | price }}
        </td>

        <td></td>
    </tr>
</template>

<script>
    export default {
        props: ['subscriptionPeriod', 'portal', 'selectedBuyables'],

        computed: {
            selected() {
                return this.selectedBuyables.findIndex(existing => existing === this.subscriptionPeriod) > -1
            }
        },

        methods: {
            select() {
                if (this.selected) {
                    return this.$emit('remove-subscription-period', this.subscriptionPeriod)
                }

                return this.$emit('add-subscription-period', this.subscriptionPeriod)
            }
        }
    }
</script>
